import { forwardRef } from "react";

// Renders the CARFAX HTML. Ref is forwarded so the parent can export to PDF.
const ReportViewer = forwardRef(function ReportViewer({ html }, ref) {
    if (!html) {
        return (
            <div className="report report--empty">
                <div className="report__empty-icon">🔍</div>
                <p>Enter a 17-character VIN above to pull a report.</p>
            </div>
        );
    }
    return <div className="report" ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
});

export default ReportViewer;
